module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "chapter0"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781446350935_epub_int_r1.htm"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781446350935_epub_fm_r1.htm"
    }
  }, [_vm._v("Getting Started")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/6-1.jpg"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781446350935_epub_c01_r1.htm"
    }
  }, [_vm._v(" Hidden in the Stars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/6-4.jpg"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781446350935_epub_c02_r1.htm"
    }
  }, [_vm._v(" Pick and Mix")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/6-7.jpg"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781446350935_epub_c03_r1.htm"
    }
  }, [_vm._v(" Vertical Drop")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/6-10.jpg"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781446350935_epub_c04_r1.htm"
    }
  }, [_vm._v(" May Flowers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/6-2.jpg"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781446350935_epub_c05_r1.htm"
    }
  }, [_vm._v(" Peace Medallion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/6-5.jpg"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781446350935_epub_c06_r1.htm"
    }
  }, [_vm._v(" Beach Hut Parade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/6-8.jpg"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781446350935_epub_c07_r1.htm"
    }
  }, [_vm._v(" Birthday Gift")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/6-11.jpg"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781446350935_epub_c08_r1.htm"
    }
  }, [_vm._v(" Knickerbocker Glory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/6-3.jpg"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781446350935_epub_c09_r1.htm"
    }
  }, [_vm._v(" Candy Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/6-6.jpg"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781446350935_epub_c10_r1.htm"
    }
  }, [_vm._v(" Zen and the Jelly Roll")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/6-9.jpg"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781446350935_epub_c11_r1.htm"
    }
  }, [_vm._v(" Jelly Roll Bargello")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/6-12.jpg"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781446350935_epub_c12_r1.htm"
    }
  }, [_vm._v(" Be My Valentine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/6-13.jpg"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781446350935_epub_c13_r1.htm"
    }
  }, [_vm._v(" Valentine Cushion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781446350935_epub_c14_r1.htm"
    }
  }, [_vm._v("General Techniques")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781446350935_epub_ack_r1.htm"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781446350935_epub_ata_r1.htm"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781446350935_epub_usc_r1.htm"
    }
  }, [_vm._v("Useful Contacts")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afdb1330","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781446350935_epub_toc_r1.vue
// module id = 63
// module chunks = 0